import React from 'react';
import { theme } from 'antd';
import { CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';

import { TOOLTIP_ROOT_ID } from '../../../components/Tooltip';

function VerifiedStateCell({ verified, deleted }: { verified: boolean; deleted: boolean }) {
  const { token } = theme.useToken();

  return (
    <div>
      {verified ? (
        <CheckCircleFilled style={{ color: deleted ? token.colorTextSecondary : token.colorPrimary }} />
      ) : (
        <div
          data-tooltip-id={TOOLTIP_ROOT_ID}
          data-tooltip-content="Prerender integration not detected"
          data-tooltip-place="top"
          style={{ display: 'inline-block' }}
        >
          <ExclamationCircleFilled style={{ color: deleted ? token.colorTextSecondary : token.red }} />
        </div>
      )}
    </div>
  );
}

export default React.memo(VerifiedStateCell);
